import { render, staticRenderFns } from "./drinkCard.vue?vue&type=template&id=373ed87d&scoped=true"
import script from "./drinkCard.vue?vue&type=script&lang=js"
export * from "./drinkCard.vue?vue&type=script&lang=js"
import style0 from "./drinkCard.vue?vue&type=style&index=0&id=373ed87d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ed87d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373ed87d')) {
      api.createRecord('373ed87d', component.options)
    } else {
      api.reload('373ed87d', component.options)
    }
    module.hot.accept("./drinkCard.vue?vue&type=template&id=373ed87d&scoped=true", function () {
      api.rerender('373ed87d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/drinkCard.vue"
export default component.exports